import { inject, Injectable } from '@angular/core';
import {
  Confirmation,
  ConfirmationService,
  MessageService,
  ToastMessageOptions,
} from 'primeng/api';
import { Subscription } from 'rxjs';

export interface TSubscription {
  key: string;
  subscription: Subscription;
}

@Injectable({ providedIn: 'root' })
export class GeneralService {
  private readonly messageService = inject(MessageService);
  private readonly confirmationService = inject(ConfirmationService);
  private readonly keyGlobalMessage = 'global-message';
  private readonly keyGlobalConfirmation = 'avisoDialog';

  #subscriptions: TSubscription[] = [];

  addSubscriptions(key: string, subscription: Subscription) {
    this.#subscriptions.push({ key, subscription });
  }

  deleteSubscriptions(key: string) {
    try {
      const subscriptions = this.#subscriptions.filter(item => item.key === key);
      for (const subscription of subscriptions) {
        subscription.subscription.unsubscribe();
      }
      this.#subscriptions = this.#subscriptions.filter(item => item.key !== key);
    } catch (error) {
      console.error('deleteSubscriptions_Error', error);
    }
  }

  deleteAllSubscriptions() {
    try {
      for (const subscription of this.#subscriptions) {
        subscription.subscription.unsubscribe();
      }
      this.#subscriptions = [];
    } catch (error) {
      console.error('deleteAllSubscriptions_Error', error);
    }
  }

  showMessage(message: ToastMessageOptions) {
    this.messageService.add({ ...message, key: this.keyGlobalMessage });
  }

  showConfirmation(message: Confirmation) {
    return this.confirmationService.confirm({ ...message, key: this.keyGlobalConfirmation });
  }
}
